import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonIconModule } from '@impairedShared/button-icon/button-icon.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { PxModule } from '@shared/pipes/px/px.module';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { SelectImpairedComponent } from './select-impaired/select-impaired.component';

@NgModule({
  declarations: [SelectImpairedComponent],
  exports: [SelectImpairedComponent],
  imports: [CommonModule, ButtonIconModule, OverlayModule, PxModule, NgLetModule]
})
export class SelectImpairedModule {}
